<template>
  <TooltipView type="is-dark" :label="$t('tools.copied-to-clipboard')" :triggers="['click']">
    <ButtonView
      icon-left="cls-hyperlink"
      icon-pack="cls"
      type="is-primary"
      @click="onCopy"
      :data-e2e="DiagnosticToolCypressAttribute.buttons.COPY_LINK"
    >
      {{ $t('tools.copy-link') }}
    </ButtonView>
  </TooltipView>
</template>

<script>
import { DiagnosticToolCypressAttribute } from '@/modules/typeform/constants/DiagnosticToolCypressAttribute';
import { DiagnosticToolSharedEventTracking } from '@/modules/typeform/models/segmentevents/DiagnosticToolSharedEventTracking';
import { ToolsRoutes } from '@/modules/typeform/routes/tools.routes';
import DeviceService from '@/modules/core/ui/services/DeviceService';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DiagnosticToolCopyLinkButton',
  components: { TooltipView, ButtonView },
  props: {
    formId: {
      type: String,
      required: true
    }
  },
  static: {
    DiagnosticToolCypressAttribute
  },
  methods: {
    async onCopy() {
      const url = `${window.location.origin}/${ToolsRoutes.DIAGNOSTIC_TOOL.path}/${this.formId}`;
      await DeviceService.copyToClipboard(url);
      DiagnosticToolSharedEventTracking.dispatch(this.formId);
    }
  }
};
</script>
